/**
 * Recent-search history stored in localStorage.
 *
 * Keeps the 5 most recent unique search queries (case-insensitive dedup)
 * so we can offer one-tap re-runs on the home page and the results page.
 *
 * All functions are safe if localStorage is unavailable (private mode / SSR).
 */
const KEY = "mc68_recent_searches";
const MAX = 5;

function _read() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr.filter((x) => typeof x === "string" && x.length > 0) : [];
  } catch {
    return [];
  }
}

function _write(list) {
  try {
    localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
  } catch { /* private mode — silently ignore */ }
}

/** Add a query to the top of the history (dedup, case-insensitive). */
export function addRecentSearch(q) {
  const cleaned = (q || "").trim();
  if (!cleaned || cleaned.length < 2) return;
  const current = _read();
  const lower = cleaned.toLowerCase();
  const filtered = current.filter((x) => x.toLowerCase() !== lower);
  _write([cleaned, ...filtered]);
}

/** Return up to `limit` most-recent searches (newest first). */
export function getRecentSearches(limit = MAX) {
  return _read().slice(0, limit);
}

/** Remove one entry (case-insensitive). */
export function removeRecentSearch(q) {
  const lower = (q || "").toLowerCase();
  _write(_read().filter((x) => x.toLowerCase() !== lower));
}

/** Wipe all history. */
export function clearRecentSearches() {
  _write([]);
}
